@if (
  {
    expanded: (expanded$ | async)!,
    count: (count$ | async)!,
    items: (items$ | async)!
  };
  as context
) {
  <now-wbsuche-lib-basis-facette
    [id]="'anbieter'"
    [label]="'Anbieter'"
    [facettenService]="facettenService"
    [isLoading]="(loaderService.anbieterFacetteLoading$ | async)!"
  >
    @if (context.expanded) {
      <now-wbsuche-lib-checkbox-facette
        [label]="'Anbieter'"
        [komponentenId]="'anbieterFacette'"
        [selectItems]="context.items"
        (selected)="updateSelectedIds($event)"
        [maxHeight]="300"
        [searchable]="true"
        [forceTextWrap]="true"
        [countOfSelectedItems]="context.count"
        [pinSelectedAtTop]="true"
        [facetteLoading]="(loaderService.anbieterFacetteLoading$ | async)!"
      ></now-wbsuche-lib-checkbox-facette>
    }
  </now-wbsuche-lib-basis-facette>
}
